<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划名称" prop="planName">
              <a-input placeholder="请输入巡检计划名称" v-model="model.planName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="下次执行时间" prop="nextTime">
              <j-date
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择下次执行时间"
                style="width: 100%"
                v-model="model.nextTime"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="周期类型" prop="planCycleType">
              <a-radio-group @change="planCycleTypeChange" button-style="solid" v-model:value="model.planCycleType">
                <a-radio-button value="2">指定每日时间</a-radio-button>
                <a-radio-button value="1">周期</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="18" v-if="model.planCycleType == '1'">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="计划周期" prop="planCycle">
              <a-radio-group button-style="solid" v-model="model.planCycle">
                <a-radio-button :value="'0 0 0 * * ?'">1天</a-radio-button>
                <a-radio-button :value="'0 0 0 * * 1'">1周</a-radio-button>
                <a-radio-button :value="'0 0 0 1,15 * ?'">半月</a-radio-button>
                <a-radio-button :value="'0 0 0 1 * ?'">1月</a-radio-button>
                <a-radio-button :value="'0 0 0 1 */2 ?'">2月</a-radio-button>
                <a-radio-button :value="'0 0 0 1 */3 ?'">3月</a-radio-button>
                <a-radio-button :value="'0 0 0 1 */6 ?'">半年</a-radio-button>
                <a-radio-button :value="'0 0 0 1 1 ?'">1年</a-radio-button>
                <!-- <a-radio-button :value="'0 0/30 * * * ?'">30分钟</a-radio-button>
                <a-radio-button :value="'0 0 0/1 * * ?'">1小时</a-radio-button>
                <a-radio-button :value="'0 0 0/2 * * ?'">2小时</a-radio-button>
                <a-radio-button :value="'0 0 0/3 * * ?'">3小时</a-radio-button>
                <a-radio-button :value="'0 0 0/4 * * ?'">4小时</a-radio-button>
                <a-radio-button :value="'0 0 0/6 * * ?'">6小时</a-radio-button>-->
                <a-radio-button :value="'0 0 0/8 * * ?'">8小时</a-radio-button>
                <a-radio-button :value="'0 0 0/12 * * ?'">12小时</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>

          <a-col :span="18" v-if="model.planCycleType == '2'">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="计划周期" prop="planCycle">
              <a-tabs size="small" v-model="curtab">
                <a-tab-pane key="hour" tab="时">
                  <hour-ui v-model="hour"></hour-ui>
                </a-tab-pane>
                <a-tab-pane key="minute" tab="分">
                  <minute-ui v-model="minute"></minute-ui>
                </a-tab-pane>
              </a-tabs>
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <a-form-model-item :labelCol="labelCol3" :wrapperCol="wrapperCol3" label="近十次执行时间">
              <a-textarea :rows="10" :value="preTimeList" disabled type="textarea" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs @change="handleChangeTabs" v-model="activeKey">
      <a-tab-pane :forceRender="true" :key="refKeys[0]" tab="巡检点">
        <j-editable-table
          :actionButton="true"
          :alwaysEdit="false"
          :columns="ywArtificialPatrolPlanPointTable.columns"
          :dataSource="ywArtificialPatrolPlanPointTable.dataSource"
          :disabled="formDisabled"
          :loading="ywArtificialPatrolPlanPointTable.loading"
          :maxHeight="300"
          :ref="refKeys[0]"
          :rowNumber="true"
          :rowSelection="true"
        />
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>
  import { getAction } from '@/api/manage'
  import { FormTypes, getRefPromise, VALIDATE_NO_PASSED } from '@/utils/JEditableTableUtil'
  import { JEditableTableModelMixin } from '@/mixins/JEditableTableModelMixin'
  import { validateDuplicateValue, simpleDebounce } from '@/utils/util'
  import CronParser from 'cron-parser'
  import MinuteUi from '@views/maintenance/modules/tabs/minute'
  import HourUi from '@views/maintenance/modules/tabs/hour'
  import moment from 'moment'

  export default {
    name: 'YwArtificialPatrolPlanForm',
    mixins: [JEditableTableModelMixin],
    components: {
      MinuteUi,
      HourUi
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 }
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 }
        },
        labelCol3: {
          xs: { span: 24 },
          sm: { span: 10 }
        },
        wrapperCol3: {
          xs: { span: 24 },
          sm: { span: 14 }
        },
        model: {
          nextTime: '',
          planCycleType: '1',
          planCycle: '0 0 0 1 * ?'
        },
        //周期参数
        preTimeList: '执行预览，会忽略年份参数',
        curtab: 'hour',
        second: '*',
        minute: '*',
        hour: '*',
        day: '*',
        month: '*',
        week: '?',
        year: '*',
        inputValues: { second: '', minute: '', hour: '', day: '', month: '', week: '', year: '', cron: '' },
        hideSecond: false,
        hideYear: true,
        cronValue: '',
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
          planName: [{ required: true, message: '请输入巡检计划名称!' }],
          planCycle: [{ required: true, message: '请输入计划周期!' }],
          planStatus: [{ required: true, message: '请输入计划状态!' }],
          planCycleType: [{ required: true, message: '请输入周期类型!' }]
        },
        refKeys: ['ywArtificialPatrolPlanPoint'],
        tableKeys: ['ywArtificialPatrolPlanPoint'],
        activeKey: 'ywArtificialPatrolPlanPoint',
        // 巡检计划巡检点配置
        ywArtificialPatrolPlanPointTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '巡检点',
              key: 'patrolPointId',
              type: FormTypes.select,
              dictCode: '`iwt-wf`.yw_artificial_patrol_point,point_name,id',
              width: '50%',
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
            {
              title: '序号',
              key: 'orderNo',
              type: FormTypes.inputNumber,
              width: '20%',
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{ required: true, pattern: 'z', message: '${title}格式不正确' }]
            }
          ]
        },
        url: {
          add: '/device/patrol/ywArtificialPatrolPlan/add',
          edit: '/device/patrol/ywArtificialPatrolPlan/edit',
          queryById: '/device/patrol/ywArtificialPatrolPlan/queryById',
          ywArtificialPatrolPlanPoint: {
            list: '/device/patrol/ywArtificialPatrolPlan/queryYwArtificialPatrolPlanPointByMainId'
          }
        }
      }
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
      cronValue_c () {
        let result = []
        if (!this.hideSecond) result.push(this.second ? this.second : '*')
        result.push(this.minute ? this.minute : '*')
        result.push(this.hour ? this.hour : '*')
        result.push(this.day ? this.day : '*')
        result.push(this.month ? this.month : '*')
        result.push(this.week ? this.week : '?')
        if (!this.hideYear && !this.hideSecond) result.push(this.year ? this.year : '*')
        return result.join(' ')
      },
      cronValue_c2 () {
        const v = this.cronValue_c
        if (this.hideYear || this.hideSecond) return v
        const vs = v.split(' ')
        if (vs.length >= 6) {
          // 将 Quartz 星期 的规则转换为 CronParser 的规则
          vs[5] = this.convertQuartzWeekToCParser(vs[5])
        }
        return vs.slice(0, vs.length - 1).join(' ')
      },
      formDisabled () {
        return this.disabled
      },
      userInfo () {
        return this.$store.getters.userInfo
      }
    },
    watch: {
      cronValue (newVal, oldVal) {
        if (newVal === this.cronValue_c) {
          // console.info('same cron value: ' + newVal)
          return
        }
        this.formatValue()
      },
      cronValue_c (newVal, oldVal) {
        this.calTriggerList1()
        this.$set(this.model, 'planCycle', newVal)
        this.assignInput()
      },
      minute () {
        if (this.second === '*') {
          this.second = '0'
        }
      },
      hour () {
        if (this.minute === '*') {
          this.minute = '0'
        }
      },
      day (day) {
        if (day !== '?' && this.hour === '*') {
          this.hour = '0'
        }
      },
      'model.planCycle' (newVal, oldVal) {
        this.calTriggerList()
        this.$emit('change', newVal)
      }
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
    },
    methods: {
      add () {
        // 统一设置默认值
        this.modelDefault.planName = ''
        this.modelDefault.planStatus = 0
        this.modelDefault.planCycleType = '1'
        this.modelDefault.planCycle = '0 0 0/1 * * ?'
        this.modelDefault.createBy = this.userInfo.id
        this.edit(this.modelDefault)
      },
      planCycleTypeChange () {
        if (this.model.planCycleType == '1') {
          this.model.planCycle = '0 0 0/1 * * ?'
        } else if (this.model.planCycleType == '2') {
          this.cronValue = '0 0 0 * * ?'
          this.model.planCycle = '0 0 0 * * ?'
          this.formatValue()
          this.$nextTick(() => {
            this.calTriggerListInner1()
          })
        }
      },
      calTriggerList1: simpleDebounce(function () {
        this.calTriggerListInner1()
      }, 500),
      calTriggerListInner1 () {
        // 设置了回调函数
        if (this.remote) {
          this.remote(this.cronValue_c, +new Date(), v => {
            this.preTimeList = v
          })
          return
        }
        const format = 'YYYY-MM-DD HH:mm:ss'
        const options = {
          currentDate: moment().toDate()
        }
        const iter = CronParser.parseExpression(this.cronValue_c2, options)
        const result = []
        for (let i = 1; i <= 10; i++) {
          const nextDate = iter.next()
          result.push(moment(nextDate.toDate()).format(format))
        }
        this.preTimeList = result.length > 0 ? result.join('\n') : '无执行时间'
      },
      calTriggerList: simpleDebounce(function () {
        this.calTriggerListInner()
      }, 500),
      calTriggerListInner () {
        if (!this.model.planCycle) return

        const format = 'YYYY-MM-DD HH:mm:ss'
        const options = {
          currentDate: moment().toDate()
        }

        try {
          const iter = CronParser.parseExpression(this.model.planCycle, options)
          const result = []
          for (let i = 1; i <= 10; i++) {
            const nextDate = iter.next()
            result.push(moment(nextDate.toDate()).format(format))
          }
          this.preTimeList = result.join('\n')
        } catch (e) {
          console.error('解析cron表达式失败:', e)
          this.preTimeList = '无效的cron表达式'
        }
      },

      addBefore () {
        this.ywArtificialPatrolPlanPointTable.dataSource = []
      },
      getAllTable () {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter () {
        this.$nextTick(() => { })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(
            this.url.ywArtificialPatrolPlanPoint.list,
            params,
            this.ywArtificialPatrolPlanPointTable
          )
        }
      },
      //校验所有一对一子表表单
      validateSubForm (allValues) {
        return new Promise((resolve, reject) => {
          Promise.all([])
            .then(() => {
              resolve(allValues)
            })
            .catch(e => {
              if (e.error === VALIDATE_NO_PASSED) {
                // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
                this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
              } else {
                console.error(e)
              }
            })
        })
      },
      /** 整理成formData */
      classifyIntoFormData (allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          ywArtificialPatrolPlanPointList: allValues.tablesValue[0].values
        }
      },
      validateError (msg) {
        this.$message.error(msg)
      },
      assignInput () {
        Object.assign(this.inputValues, {
          second: this.second,
          minute: this.minute,
          hour: this.hour,
          day: this.day,
          month: this.month,
          week: this.week,
          year: this.year,
          cron: this.cronValue_c
        })
      },
      formatValue () {
        if (!this.cronValue) return
        const values = this.cronValue.split(' ').filter(item => !!item)
        if (!values || values.length <= 0) return
        let i = 0
        if (!this.hideSecond) this.second = values[i++]
        if (values.length > i) this.minute = values[i++]
        if (values.length > i) this.hour = values[i++]
        if (values.length > i) this.day = values[i++]
        if (values.length > i) this.month = values[i++]
        if (values.length > i) this.week = values[i++]
        if (values.length > i) this.year = values[i]
        this.assignInput()
      },
      // 将 Quartz 星期 的规则转换为 CronParser 的规则：
      // Quartz 的规则：1 = 周日，2 = 周一，3 = 周二，4 = 周三，5 = 周四，6 = 周五，7 = 周六
      // CronParser 的规则： 0 = 周日，1 = 周一，2 = 周二，3 = 周三，4 = 周四，5 = 周五，6 = 周六，7 = 周日
      convertQuartzWeekToCParser (week) {
        let convert = v => {
          if (v === '0') {
            return '1'
          }
          if (v === '1') {
            return '0'
          }
          return (Number.parseInt(v) - 1).toString()
        }
        // 匹配示例 1-7 or 1/7
        let patten1 = /^([0-7])([-/])([0-7])$/
        // 匹配示例 1,4,7
        let patten2 = /^([0-7])(,[0-7])+$/
        if (/^[0-7]$/.test(week)) {
          return convert(week)
        } else if (patten1.test(week)) {
          return week.replace(patten1, ($0, before, separator, after) => {
            if (separator === '/') {
              return convert(before) + separator + after
            } else {
              return convert(before) + separator + convert(after)
            }
          })
        } else if (patten2.test(week)) {
          return week
            .split(',')
            .map(v => convert(v))
            .join(',')
        }
        return week
      }
    }
  }
</script>

<style scoped></style>
